/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ active: NonNullable<unknown>, pending: NonNullable<unknown> }} Memberscounts1Inputs */

const en_memberscounts1 = /** @type {(inputs: Memberscounts1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.active} members · ${i?.pending} requests`)
};

const de_memberscounts1 = /** @type {(inputs: Memberscounts1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.active} Mitglieder · ${i?.pending} Anfragen`)
};

/**
* | output |
* | --- |
* | "{active} members · {pending} requests" |
*
* @param {Memberscounts1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const memberscounts1 = /** @type {((inputs: Memberscounts1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memberscounts1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_memberscounts1(inputs)
	return de_memberscounts1(inputs)
});
export { memberscounts1 as "membersCounts" }